import type { FC } from "react"
import React from "react"

import { useRecoilValue } from "recoil"

import Image from "./Elements/Image"
import { imageSourceState } from "../state/view"

const ImageGroup_Internal: FC = () => {
  const [currentImageSource] = useRecoilValue(imageSourceState)

  return <Image key={currentImageSource} id={currentImageSource} />
}

export const ImageGroup = React.memo(ImageGroup_Internal)

export default ImageGroup
